import {VatRate} from "../../../libs/enum/vat-rate.enum";

export class InvoiceVatDto {

  public readonly id!: string;
  public readonly vatRate!: VatRate;
  public readonly vatRateValue!: number;
  public readonly netAmount!: number;
  public readonly grossAmount!: number;
  public readonly vatAmount!: number;
  public readonly netAmountWithoutDiscount!: number;
  public readonly grossAmountWithoutDiscount!: number;
  public readonly vatAmountWithoutDiscount!: number;
  public readonly oldPart!: boolean;

  constructor(init?: Partial<InvoiceVatDto> | undefined) {
    Object.assign(this, init);
  }
}
